export default __webpack_public_path__ + "static/media/recent2.006de808.png";